export class User {
  id: number
  login_id: string
  name: string
  role: string
  curriculum_id: string
  email: string
  birthday: Date
  login_count: number
  last_login_at: Date
  is_active: boolean
  is_active_cache: boolean
  touan_upload_auth: boolean
  scoring_auth: boolean
  aggregate_auth: boolean
  broese_auth: boolean
  pending_scoring_auth: boolean
  user_rooms: UserRoom[]
  curriculums: Curriculum[] = new Array<Curriculum>()

  constructor(user: any, curriculums: any[]){
    this.id = user.id;
    this.login_id = user.login_id;
    this.name = user.name;
    this.role = user.role;
    this.curriculum_id = user.curriculum_id;
    this.email = user.email;
    this.birthday = user.birthday;
    this.login_count = user.login_count;
    this.last_login_at = user.last_login_at;
    this.is_active = user.is_active;
    this.is_active_cache = user.is_active;
    this.touan_upload_auth = user.touan_upload_auth;
    this.scoring_auth = user.scoring_auth;
    this.aggregate_auth = user.aggregate_auth;
    this.broese_auth = user.broese_auth;
    this.pending_scoring_auth = user.pending_scoring_auth;
    this.user_rooms = user.user_rooms;

    if(this.curriculum_id){
      const curriculumIds = this.curriculum_id.split(",");
      curriculums.forEach((x: any) => {
        const is_selected = curriculumIds.includes(`${x.id}`);
        this.curriculums.push(new Curriculum(x, is_selected));
      });
    }else{
      curriculums.forEach((x: any) => {
        this.curriculums.push(new Curriculum(x, false));
      });
    }
  }
}

export class Curriculum {
  id: number
  name: string
  is_selected: boolean

  constructor(curriculum: any, is_selected: boolean){
    this.id = curriculum.id;
    this.name = curriculum.name;
    this.is_selected = is_selected;
  }
}

export interface Room {
  id: number;
  name: string;
  room_code: number;
}

interface UserRoom {
  id: number;
  user_id: number;
  room_code: number;
}